<template>
  <div>
    <div class="align-btn">
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="左对齐"
          placement="bottom"
      >
        <span class="icon-portal-Align-left" @click="horizontalAlignEv('left',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="垂直居中对齐"
          placement="bottom"
      >
        <span class="icon-portal-Center-lr" @click="horizontalAlignEv('mid',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="右对齐"
          placement="bottom"
      >
        <span class="icon-portal-Align-right" @click="horizontalAlignEv('right',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="顶对齐"
          placement="bottom"
      >
        <span class="icon-portal-Align-up" @click="verticalAlignEv('top',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="水平居中对齐"
          placement="bottom"
      >
        <span class="icon-portal-Center-ud" @click="verticalAlignEv('mid',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 1 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="底对齐"
          placement="bottom"
      >
        <span class="icon-portal-bottom-justify" @click="verticalAlignEv('bottom',selectComponentsIds.length > 1 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 2 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="水平等间距"
          placement="bottom"
      >
        <span class="icon-portal-Hori-equidistance" @click="horizontalAlignEv('h-space-around',selectComponentsIds.length > 2 && isShowAlign)"></span>
      </el-tooltip>
      <el-tooltip
          class="item"
          :class="selectComponentsIds.length > 2 && isShowAlign? '' : 'disabled'"
          :open-delay="1000"
          effect="dark"
          content="垂直等间距"
          placement="bottom"
      >
        <span class="icon-portal-Vertical-equidistance" @click="verticalAlignEv('v-space-around',selectComponentsIds.length > 2 && isShowAlign)"></span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "alignHelper",
  data() {
    return {
      selectComponentsIds: [],
      isShowAlign: true
    }
  },
  watch: {
    "$store.state.states.activeID": {
      deep: true,
      handler(newVal, oldVal) {
        let selectComponentsIds = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        let multipleComponent = localStorage.getItem("multipleComponent")
        this.selectComponentsIds = multipleComponent ? selectComponentsIds : []
      }
    },
    "selectComponentsIds"(n,o){
        if(n.length !== o.length){
          this.isShowAlign = true
          for(let i=0;i<n.length;i++){
            let attribute =
                n[i].hasOwnProperty("elementInLayoutId") &&
                n[i].elementInLayoutId !== null &&
                typeof n[i].elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](n[i])
                    : this.getRectAttribute.call(this, n[i]).options
            if(attribute.topType === '%' || attribute.leftType === '%' || attribute.widthType === '%' || attribute.heightType === '%'){
                  this.isShowAlign = false
                  break
            }
          }
        }
    }
  },
  methods: {
    verticalAlignEv(type,isAble) {
      // 置灰之后不可点击
      if(!isAble){
        return
      }
      const masterIds = JSON.parse(JSON.stringify(this.selectComponentsIds[0]))
      const masterAttribute =
          this.selectComponentsIds[0].hasOwnProperty("elementInLayoutId") &&
          this.selectComponentsIds[0].elementInLayoutId !== null &&
          typeof this.selectComponentsIds[0].elementInLayoutId !== "undefined"
              ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
              : this.getRectAttribute.call(this, this.selectComponentsIds[0]).options
      const slaveElementIds = this.selectComponentsIds.slice(1)
      let slaveAttribute = null
      // layout里面 同一个col里面的元素
      const sameColsStatus = masterIds.elementInLayoutId !== null && typeof masterIds.elementInLayoutId !== "undefined"
      slaveElementIds.every(item => {
        return item.uid === masterIds.uid && item.container_id === this.selectComponentsIds[0].container_id
      })
      // layout里面 不同col里面的元素
      const differentColsStatus =
          masterIds.elementInLayoutId !== null && typeof masterIds.elementInLayoutId !== "undefined"
      slaveElementIds.some(item => {
        return item.uid !== masterIds.uid
      }) &&
      slaveElementIds.every(item => {
        return item.container_id === masterIds.container_id && item.rect_id === masterIds.rect_id
      })
      // 普通元素 - 不在layout里面
      const normalElementStatus = this.selectComponentsIds.every(item => {
        return (
            (item.elementInLayoutId === null ||
                typeof item.elementInLayoutId === "undefined" ||
                !item.hasOwnProperty("elementInLayoutId")) &&
            item.container_id === this.selectComponentsIds[0].container_id
        )
      })
      switch (type) {
        case "top":
          let minTop = masterAttribute.top
          slaveElementIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
                    : this.getRectAttribute.call(this, componentIds).options
            minTop = attribute.top < minTop ? attribute.top : minTop
          })
          if (sameColsStatus) {
            this.selectComponentsIds.forEach(item => {
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "top",
                option_val: parseInt(minTop)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              this.$store.dispatch(this.request_prefix + "/setTop", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                top: parseInt(minTop)
              })
            })
          }
          break
        case "mid":
          let midMinTop = masterAttribute.top
          let midMaxBottom = masterAttribute.top + masterAttribute.height
          slaveElementIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](componentIds)
                    : this.getRectAttribute.call(this, componentIds).options
            midMinTop = attribute.top < midMinTop ? attribute.top : midMinTop
            midMaxBottom =
                attribute.top + attribute.height > midMaxBottom ? attribute.top + attribute.height : midMaxBottom
          })
          let midTop = Math.floor(midMinTop + (midMaxBottom - midMinTop) / 2)
          if (sameColsStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](item)
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "top",
                option_val: parseInt(midTop - slaveAttribute.height / 2)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setTop", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                top: parseInt(midTop - slaveAttribute.height / 2)
              })
            })
          }
          break
        case "bottom":
          let maxBottom = masterAttribute.top + masterAttribute.height
          slaveElementIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
                    : this.getRectAttribute.call(this, componentIds).options
            maxBottom = attribute.top + attribute.height > maxBottom ? attribute.top + attribute.height : maxBottom
          })
          if (sameColsStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](item)
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "top",
                option_val: parseInt(maxBottom - slaveAttribute.height)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setTop", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                top: parseInt(maxBottom - slaveAttribute.height)
              })
            })
          }
          break
        case "v-space-around":
          let spaceMinTop = masterAttribute.top
          let spaceMaxBottom = masterAttribute.top + masterAttribute.height
          let totalHeight = 0
          let newSelectElementIds = []
          this.selectComponentsIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](componentIds)
                    : this.getRectAttribute.call(this, componentIds).options
            newSelectElementIds.push({
              ...componentIds,
              top: attribute.top,
              height: attribute.height
            })
            spaceMinTop = attribute.top < spaceMinTop ? attribute.top : spaceMinTop
            spaceMaxBottom =
                attribute.top + attribute.height > spaceMaxBottom ? attribute.top + attribute.height : spaceMaxBottom
            totalHeight = totalHeight + attribute.height
          })
          let spaceMargin = Math.floor((spaceMaxBottom - spaceMinTop - totalHeight) / slaveElementIds.length)
          // 对数据进行升序排序
          newSelectElementIds.sort((a, b) => {
            return a.top - b.top
          })
          let prevElementTop = newSelectElementIds[0].top
          let prevElementHeight = 0
          if (sameColsStatus) {
            newSelectElementIds.forEach((item, index) => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](item)
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "top",
                option_val:
                    index === 0 ? parseInt(prevElementTop + prevElementHeight) : parseInt(prevElementTop + prevElementHeight + spaceMargin)
              })
              prevElementTop = slaveAttribute.top
              prevElementHeight = slaveAttribute.height
            })
          }
          if (normalElementStatus) {
            newSelectElementIds.forEach((item, index) => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setTop", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                top: index === 0 ? parseInt(prevElementTop + prevElementHeight) : parseInt(prevElementTop + prevElementHeight + spaceMargin)
              })
              prevElementTop = slaveAttribute.top
              prevElementHeight = slaveAttribute.height
            })
          }
          break
        default:
          break
      }
    },
    horizontalAlignEv(type,isAble) {
      if (
          !this.selectComponentsIds ||
          !Array.isArray(this.selectComponentsIds) ||
          this.selectComponentsIds.length === 1 ||
          !isAble
      ) {
        return
      }
      const masterIds = JSON.parse(JSON.stringify(this.selectComponentsIds[0]))
      const slaveElementIds = this.selectComponentsIds.slice(1)
      const firstComponentLayoutId = this.selectComponentsIds[0].elementInLayoutId
      const masterAttribute =
          firstComponentLayoutId !== null && typeof firstComponentLayoutId !== "undefined"
              ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
              : this.getRectAttribute.call(this, this.selectComponentsIds[0])?.options
      let slaveAttribute = null
      // layout里面 同一个col里面的元素
      const sameColsStatus = masterIds.elementInLayoutId !== null && typeof masterIds.elementInLayoutId !== "undefined"
      slaveElementIds.every(item => {
        return item.uid === masterIds.uid && item.container_id === masterIds.container_id
      })
      // layout里面 不在同一个col里面的元素
      const differentColsStatus =
          masterIds.hasOwnProperty("elementInLayoutId") &&
          masterIds.elementInLayoutId !== null &&
          typeof masterIds.elementInLayoutId !== "undefined"
      slaveElementIds.some(item => {
        return item.uid !== masterIds.uid
      }) &&
      slaveElementIds.every(item => {
        return item.container_id === masterIds.container_id && item.rect_id === masterIds.rect_id
      })
      // 普通元素 - 不在layout里面
      const normalElementStatus = this.selectComponentsIds.every(item => {
        return (
            item.elementInLayoutId === null ||
            typeof item.elementInLayoutId === "undefined" ||
            !item.hasOwnProperty("elementInLayoutId")
        )
      })

      switch (type) {
        case "left":
          let minLeft = masterAttribute.left
          this.selectComponentsIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") && componentIds.elementInLayoutId !== null
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
                    : this.getRectAttribute.call(this, componentIds).options
            minLeft = attribute.left < minLeft ? attribute.left : minLeft
          })
          if (sameColsStatus) {
            slaveElementIds.forEach(item => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](
                  Object.assign(masterIds, {
                    elementInLayoutId: item.elementInLayoutId
                  })
              )
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "left",
                option_val: parseInt(minLeft)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              this.$store.dispatch(this.request_prefix + "/setLeft", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                left: parseInt(minLeft)
              })
            })
          }
          break
        case "mid":
          let midMinLeft = masterAttribute.left
          let midMaxRight = masterAttribute.left + masterAttribute.width
          slaveElementIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](componentIds)
                    : this.getRectAttribute.call(this, componentIds).options
            midMinLeft = attribute.left < midMinLeft ? attribute.left : midMinLeft
            midMaxRight =
                attribute.left + attribute.width > midMaxRight ? attribute.left + attribute.width : midMaxRight
          })
          let midLeft = Math.floor(midMinLeft + (midMaxRight - midMinLeft) / 2)
          if (sameColsStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](
                  Object.assign(masterIds, {
                    elementInLayoutId: item.elementInLayoutId
                  })
              )
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "left",
                option_val: parseInt(midLeft - slaveAttribute.width / 2)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setLeft", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                left: parseInt(midLeft - slaveAttribute.width / 2)
              })
            })
          }
          break
        case "right":
          let maxRight = masterAttribute.left + masterAttribute.width
          slaveElementIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](masterIds)
                    : this.getRectAttribute.call(this, componentIds).options
            maxRight = attribute.left + attribute.width > maxRight ? attribute.left + attribute.width : maxRight
          })
          if (sameColsStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](
                  Object.assign(masterIds, {
                    elementInLayoutId: item.elementInLayoutId
                  })
              )
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "left",
                option_val: parseInt(maxRight - slaveAttribute.width)
              })
            })
          }
          if (normalElementStatus) {
            this.selectComponentsIds.forEach(item => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setLeft", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                left: parseInt(maxRight - slaveAttribute.width)
              })
            })
          }
          break
        case "h-space-around":
          let spaceMinLeft = masterAttribute.left
          let spaceMaxRight = masterAttribute.left + masterAttribute.width
          let totalWidth = 0
          let newSelectElementIds = []
          this.selectComponentsIds.forEach(componentIds => {
            let attribute =
                componentIds.hasOwnProperty("elementInLayoutId") &&
                componentIds.elementInLayoutId !== null &&
                typeof componentIds.elementInLayoutId !== "undefined"
                    ? this.$store.getters[this.request_prefix + "/getLayoutOptions"](componentIds)
                    : this.getRectAttribute.call(this, componentIds).options
            newSelectElementIds.push({
              ...componentIds,
              left: attribute.left,
              width: attribute.width
            })
            spaceMinLeft = attribute.left < spaceMinLeft ? attribute.left : spaceMinLeft
            spaceMaxRight =
                attribute.left + attribute.width > spaceMaxRight ? attribute.left + attribute.width : spaceMaxRight
            totalWidth = totalWidth + attribute.width
          })
          let spaceMargin = Math.floor((spaceMaxRight - spaceMinLeft - totalWidth) / slaveElementIds.length)
          // 对数据进行升序排序
          newSelectElementIds.sort((a, b) => {
            return a.left - b.left
          })
          let prevElementLeft = newSelectElementIds[0].left
          let prevElementWidth = 0
          if (sameColsStatus) {
            newSelectElementIds.forEach((item, index) => {
              slaveAttribute = this.$store.getters[this.request_prefix + "/getLayoutOptions"](
                  Object.assign(masterIds, {
                    elementInLayoutId: item.elementInLayoutId
                  })
              )
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", {
                ...item,
                option_name: "left",
                option_val:
                    index === 0 ? parseInt(prevElementLeft + prevElementWidth) : parseInt(prevElementLeft + prevElementWidth + spaceMargin)
              })
              prevElementLeft = slaveAttribute.left
              prevElementWidth = slaveAttribute.width
            })
          }
          if (normalElementStatus) {
            newSelectElementIds.forEach((item, index) => {
              slaveAttribute = this.getRectAttribute.call(this, item).options
              this.$store.dispatch(this.request_prefix + "/setLeft", {
                container_id: item.container_id,
                rect_id: item.rect_id,
                left:
                    index === 0 ? parseInt(prevElementLeft + prevElementWidth) : parseInt(prevElementLeft + prevElementWidth + spaceMargin)
              })
              prevElementLeft = slaveAttribute.left
              prevElementWidth = slaveAttribute.width
            })
          }
          break
        default:
          break
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  }
}
</script>

<style scoped>
.align-btn {
  padding: 0 8px;
}
.align-btn .item {
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: 18px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  color: var(--iconColor);
  margin: 0 1px;
}
.align-btn .item:not(.disabled):hover {
  background-color: var(--inputIconHoverBgColor);
  color: var(--collapsibleItemHeadingColor);
}
.align-btn .item.disabled {
  color: var(--borderColorEle);
}
</style>
